<br>
<div class="container">
  <form class="form" (ngSubmit)="onCrearComentarioSubmit()" [formGroup]="restoreFormGroup">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <mat-label>Comentario</mat-label>
          <textarea matInput formControlName="comment"></textarea>
        </mat-form-field>
      </div>
      <div class="col-md-12" style="display: flex; gap: 1rem;">
        <button class="full-width" mat-button type="button" (click)="onCancel()">
          Cancelar
        </button>
        <button class="full-width" [disabled]="!restoreFormGroup.valid || fetchingRestore" mat-flat-button
          type="submit">
          <div>
            @if (fetchingRestore) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else{
            <p>Recuperar</p>
            }
          </div>
        </button>
      </div>
    </div>
  </form>
  <div class="table-container">
    <h4>Documentos seleccionados</h4>
    <table mat-table [dataSource]="documentsDataSource" >
      <ng-container matColumnDef="asunto">
        <th mat-header-cell *matHeaderCellDef> Asunto </th>
        <td mat-cell *matCellDef="let element"> {{element.asunto}} </td>
      </ng-container>

      <ng-container matColumnDef="de">
        <th mat-header-cell *matHeaderCellDef> De </th>
        <td mat-cell *matCellDef="let element">
          @for (item of element.de; track $index) {
          <p>{{item.nombres}}</p>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="para">
        <th mat-header-cell *matHeaderCellDef> Para </th>
        <td mat-cell *matCellDef="let element">
          @for (item of element.para; track $index) {
          <p>{{item.nombres}}</p>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef> Fecha </th>
        <td mat-cell *matCellDef="let element"> {{formatDate(element.fecha)}} </td>
      </ng-container>

      <ng-container matColumnDef="numero">
        <th mat-header-cell *matHeaderCellDef> Numero documento</th>
        <td mat-cell *matCellDef="let element"> {{element.numeroDocumento}} </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef> Estado </th>
        <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
